import React, {FC, Fragment, useState, useEffect, useCallback} from 'react';
import Header from "./components/header/header";
import Title from "./components/title/title";
import Button from "./components/button/button";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import Thumb from "./components/thumb/thumb";
import {KeySolver} from "./helper/KeySolver";
import Preloader from "./components/preloader/preloader";
import Steps from "./components/steps/steps";
import Summary from "./components/summary/summary";
import Complete from "./components/complete/complete";
import Aside from "./components/aside/aside";
import Input from "./components/form/input";
import {useGlobalState} from "./GlobalStateProvider";

const App: FC = () => {

    const [node, setNode] = useState<string|false>(false);
    const [index, setIndex] = useState<number>(0);
    const [items, setItems] = useState<any>([]);
    const [complete, setComplete] = useState<boolean>(false);
    const [completed, setCompleted] = useState<boolean>(false);
    const [aside, setAside] = useState<boolean>(false);

    const {state, setState} = useGlobalState();

    const fetchItems = useCallback(() => {

        fetch(`${process.env.REACT_APP_API_URL}/api/configurator/index/${node}`, {method: 'GET', redirect: 'follow'})
            .then(response => response.json())
            .then(result => {
                console.log(result)
                setItems(result);
            })
            .catch(error => console.log('error', error));
    }, [node]);

    const handleSetIndex = (direction: number = 0) => {
        if(items && items.children && items.children.length > 0) {
            if(direction === 1) {
                const newIndex: number = index + 1;
                if(newIndex !== items.children.length) {
                    setIndex( (index + 1) );
                }
            }
            if(direction === 0) {
                const newIndex: number = index - 1;
                if(newIndex >= 0) {
                    setIndex( (index - 1) );
                }
            }
        }
    }

    const handleSetAnnotation = () => {

        const isInSummary = (): boolean => {
            return state.annotations.some((item) => item.index === index);
        }

        const annotationInput = document.getElementById('annotationInput') as HTMLInputElement;
        if(annotationInput) {
            const value = annotationInput.value;
            if(isInSummary()) {
                const updatedAnnotations = [...state.annotations];
                const elementToReplace = updatedAnnotations.find((annotation: any) => annotation.index === index);
                if (elementToReplace) {
                    const indexOfElement: number = updatedAnnotations.indexOf(elementToReplace);
                    updatedAnnotations[indexOfElement] = {index: index, value: value};
                    setState({ ...state, annotations: updatedAnnotations });
                }
            } else {
                const updatedAnnotations = [...state.annotations, { index: index, value: value} ];
                setState({ ...state, annotations: updatedAnnotations });
            }
        }
    }

    useEffect(() => {
        console.log(state)
    }, [state]);

    useEffect(() => {
        const rootEl = document.getElementById('root') as HTMLDivElement;
        const nodeIdentifier = rootEl.dataset.node;
        if(nodeIdentifier) {
            setNode(nodeIdentifier);
        }
    }, [fetchItems]);

    useEffect(() => {
        if(node) {
            fetchItems();
        }
    }, [node, fetchItems]);

    return (
        <div className="App font-regular h-full">
            <div className="flex flex-col h-full">

                {aside && items && items.properties && items.properties.description &&
                    <Aside title="So funktionierts" setAside={(p: boolean) => setAside(p)} >
                        <span dangerouslySetInnerHTML={{__html: items.properties.description}} />
                    </Aside>
                }

                <div className="relative w-full z-[1024]">
                    <Header setAside={(p: boolean) => setAside(p)} />
                </div>

                {items && items.children && items.children.length > 0 ?
                    <div className="h-full flex flex-row p-4 lg:p-0 lg:items-center justify-center">

                        <div className="w-full max-h-[100vh] py-10 max-w-[1400px]">

                            {completed ?
                                <Fragment>
                                    <div className="flex flex-row gap-10 items-end">
                                        <div className="mb-2">
                                            <FontAwesomeIcon icon={icon({name: 'check'})} className="text-[42px] text-green-500" />
                                        </div>
                                        <div>
                                            <Title title="Vielen Dank" description="Ihre Anfrage wurde versendet" hide={true} />
                                            <div>Wir melden uns gschwind bei Ihnen!</div>
                                        </div>
                                    </div>
                                </Fragment>
                                :
                                <Fragment>
                                    {complete &&
                                        <Fragment>
                                            <div className="flex flex-col gap-3">

                                                <Complete
                                                    summary={
                                                        <Summary basePrice={items.properties.basePrice} model={items.properties.title} rangeOfFluctuation={items.properties.rangeOfFluctuation} />
                                                    }
                                                    buttons={
                                                        <div className="flex flex-row gap-5 items-center">

                                                            <Button onClick={() => setComplete(false)} >
                                                                <div className="flex flex-row gap-3 items-center">
                                                                    <div className="border-r-[1px] border-r-white pe-3">
                                                                        <FontAwesomeIcon icon={icon({name: 'arrow-left-long'})} />
                                                                    </div>
                                                                    <span>Zurück</span>
                                                                </div>
                                                            </Button>

                                                            <Button type="submit" >
                                                                <div className="flex flex-row gap-3 items-center">
                                                                    <div className="border-r-[1px] border-r-white pe-3">
                                                                        <FontAwesomeIcon icon={icon({name: 'arrow-right-long'})} />
                                                                    </div>
                                                                    <span>Absenden</span>
                                                                </div>
                                                            </Button>

                                                        </div>
                                                    }
                                                    setCompleted={(p: boolean) => setCompleted(p)}
                                                />

                                            </div>
                                        </Fragment>
                                    }

                                    {!complete &&
                                        <Fragment>

                                            <Steps index={index + 1} children={items.children} length={(items.children.length)} setIndex={(p: number) => setIndex(p)} />

                                            {items.children.map((item: any, page: number) =>
                                                <Fragment key={KeySolver()} >

                                                    {page === index &&

                                                        <Fragment>
                                                            <Title title={item.properties.title} description={item.properties.description} />

                                                            {item.properties.infoText &&
                                                                <div className="mt-5 text-gray-400">
                                                                    <div className="flex flex-row gap-2">
                                                                        <div>
                                                                            <FontAwesomeIcon icon={icon({name: 'circle-info'})} />
                                                                        </div>
                                                                        <div>
                                                                            {item.properties.infoText}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }

                                                            {item.children && item.children.length > 0 &&
                                                                <div className={`${item.children[0].properties.layout === 'row' ? 'flex flex-col w-full lg:max-w-[50%]' : 'grid grid-cols-2 lg:flex lg:flex-row'} gap-5 lg:gap-10 my-5 lg:my-10`}>
                                                                    {item.children.map((childrenItem: any, iterator: number) =>
                                                                        <Fragment key={KeySolver()} >
                                                                            <Thumb parentProperties={item.properties} identifier={childrenItem.identifier} properties={childrenItem.properties} parentIndex={page} index={iterator} onClick={() => {}} />
                                                                        </Fragment>
                                                                    )}
                                                                </div>
                                                            }

                                                            {item.properties.enableAnnotations &&
                                                                <div className="grid lg:grid-cols-2 gap-10 mb-10">
                                                                    <Input type="textarea" label={`Wollen Sie uns zu "Auswahl ${item.properties.title}" noch etwas mitteilen?`} id="annotationInput" className="h-[5rem]" defaultValue={state && state.annotations.length > 0 && state.annotations.find((annotation: any) => annotation.index === index) ? state.annotations.find((annotation) => annotation.index === index).value : ''} onBlur={() => handleSetAnnotation()} />
                                                                </div>
                                                            }

                                                        </Fragment>

                                                    }

                                                </Fragment>
                                            )}

                                            <div className="flex flex-row gap-5 mb-10 pb-10 items-center">

                                                {index !== 0 &&
                                                    <Button onClick={() => { handleSetAnnotation(); handleSetIndex(0); }} >
                                                        <div className="flex flex-row gap-3 items-center">
                                                            <div className="border-r-[1px] border-r-white pe-3">
                                                                <FontAwesomeIcon icon={icon({name: 'arrow-left-long'})} />
                                                            </div>
                                                            <span>Zurück</span>
                                                        </div>
                                                    </Button>
                                                }

                                                {index !== (items.children.length - 1) &&
                                                    <Button onClick={() => { handleSetAnnotation(); handleSetIndex(1); }} >
                                                        <div className="flex flex-row gap-3 items-center">
                                                            <div className="border-r-[1px] border-r-white pe-3">
                                                                <FontAwesomeIcon icon={icon({name: 'arrow-right-long'})} />
                                                            </div>
                                                            <span>Weiter</span>
                                                        </div>
                                                    </Button>
                                                }

                                                {index === (items.children.length - 1) &&
                                                    <Button onClick={() => { handleSetAnnotation(); setComplete(true); }} >
                                                        <div className="flex flex-row gap-3 items-center">
                                                            <div className="border-r-[1px] border-r-white pe-3">
                                                                <FontAwesomeIcon icon={icon({name: 'arrow-right-long'})} />
                                                            </div>
                                                            <span>Abschließen</span>
                                                        </div>
                                                    </Button>
                                                }

                                            </div>

                                        </Fragment>
                                    }
                                </Fragment>
                            }

                        </div>
                    </div>
                    :
                    <div className="fixed w-full h-full left-0 top-0 z-[1093] bg-white flex flex-row items-center justify-center">
                        <Preloader text="Konfigurator wird geladen ..." />
                    </div>
                }
            </div>
        </div>
    );
}

export default App;
